import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 画面項目設定 - ログインパートナー取得
export async function getScreenColumnConfigLoginCompanys(id: string) {
  try {
    const path = "screenColumnConfigLoginCompanys";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      entry_sale_company_datas: response.data.entry_sale_company_data,
    };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}

// 画面項目設定 - ログインパートナー一覧登録
export async function postScreenColumnConfigLoginCompanys(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "screenColumnConfigLoginCompanys";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
